module.exports = __webpack_public_path__ + "img/Filters.78234c37.svg";